import ReactDOMServer from 'react-dom/server';
import xmlButPrettier from 'xml-but-prettier';
import { ReplaceAll } from '../Util';

const replaceStrings = {
	siteresourcespackagekey: 'siteResourcesPackageKey',
	sitenodename: 'siteNodeName',
	formatversion: 'formatVersion',
	nodename: 'nodeName',
	sortingindex: 'sortingIndex',
	nodetype: 'nodeType',
	hiddeninindex: 'hiddenInIndex',
	accessroles: 'accessRoles',
	creationdatetime: 'creationDateTime',
	lastmodificationdatetime: 'lastModificationDateTime',
	lastpublicationdatetime: 'lastPublicationDateTime',
	uripathsegment: 'uriPathSegment'
}

const XmlRoot = (props) => {
	const children = props.children ? props.children : null;

	const xml = (`
<root>
${ReactDOMServer.renderToStaticMarkup(children)}
</root>
	`);

	return `<?xml version="1.0" encoding="UTF-8"?>
${xmlButPrettier(ReplaceAll(xml, replaceStrings), {indentor: ' ', textNodesOnSameLine: true})}`;
};

export default XmlRoot;



// WEBPACK FOOTER //
// ./src/components/Xml/XmlRoot.js